import React, {useContext} from 'react';
import {View, Platform} from 'react-native';
import {useNavigation} from '@react-navigation/native';

import Text from '../../elements/Text';
import Button from '../../elements/Button';
import DashedDivider from '../../elements/DashedDivider';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import ProductCard from '../ProductCard';
import {shopContext} from '../../../contexts/ShopContext';
import {trackEvent} from '../../../utils/Analytics';

const BuyAgainCard = ({item, index}) => {
  const ShopC = useContext(shopContext);
  const navigation = useNavigation();
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);

  const onPressBuyAgain = () => {
    trackEvent('Add to Cart', {productid: item.product.id});

    let cartItems = [...ShopC.cartProducts];
    let index = 0;
    let inCart = false;
    if (cartItems.length > 0) {
      cartItems.forEach((i, idx) => {
        if (i.id == item.product.id) {
          index = idx;
          inCart = true;
        }
      });
    }

    if (inCart) {
      const p = cartItems[index];
      const product = {...p, productQty: p.productQty + item.quantity};
      cartItems[index] = product;
      ShopC.setCartProducts(cartItems);
    } else {
      const product = {...item.product, productQty: item.quantity};
      cartItems.push(product);
      ShopC.setCartProducts(cartItems);
    }
    // Same rationale as ViewProduct: show the user the item landed. Web keeps
    // its side-panel flow (this card renders native-only paths today).
    if (Platform.OS !== 'web') {
      navigation.navigate('MyCart');
    }
  };

  const renderShippingDetailsRow = (title, value) => (
    <View style={styles.shippingDetainRow}>
      <Text
        variation="Text1Regular"
        color={colors.textDisabled}
        maxFontSizeMultiplier={2}
        style={styles.shippingDetailLabel}>
        {title}
      </Text>
      <Text
        variation="Text1Regular"
        color={colors.textPrimary}
        maxFontSizeMultiplier={2}
        style={styles.shippingDetailValue}>
        {value}
      </Text>
    </View>
  );

  return (
    <View style={styles.container}>
      <ProductCard
        imageStyle={styles.productImage}
        style={styles.productInfoView}
        product={item.product}
      />
      <View style={styles.marginVertical16}>
        <DashedDivider color={colors.border} dashWidth={5} space={5} />
      </View>
      <Text variation="Text1SemiBold" color={colors.link}>
        Shipping Details
      </Text>
      {renderShippingDetailsRow('Qty', item.quantity)}
      {/* {renderShippingDetailsRow('Color', 'blue')} */}
      {renderShippingDetailsRow(
        'Total Price',
        '$ ' + (item.quantity * parseFloat(item.product.price)).toFixed(2),
      )}
      {renderShippingDetailsRow('Credit Card', '**** 4871')}
      <View style={styles.marginVertical16}>
        <DashedDivider color={colors.border} dashWidth={5} space={5} />
      </View>
      <Button
        title={'Buy Again'}
        style={styles.buyAgainButton}
        titleStyle={styles.buyAgainText}
        onPress={onPressBuyAgain}
      />
    </View>
  );
};

export default BuyAgainCard;
